import React from "react";
import Layout from "@hoc/layouts/Layout";
import VesselTypesIndex from "@components/VesselType/VesselTypesIndex";

const VesselTypesPage = () => {
  return (
    <Layout>
      <VesselTypesIndex />
    </Layout>
  );
};

export default VesselTypesPage;
